import { ISQ_DEFINITION } from "./definitions.js";
import { ISQ } from "./isq.js";
export const isq = new ISQ(ISQ_DEFINITION);
